(function () {
  function getSealProductData() {
    const sealTarget = document.querySelector(
      '.sealsubs-target-element[data-product]'
    );

    if (!sealTarget?.dataset.product) return null;

    try {
      return JSON.parse(sealTarget.dataset.product);
    } catch (error) {
      console.warn('Seal product data could not be parsed', error);
      return null;
    }
  }

  function getSealCardData() {
    const script = document.querySelector('[id^="tw-seal-card-data"]');

    if (!script?.textContent) {
      return {
        product: {},
        variants: {}
      };
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Seal card data JSON could not be parsed', error);

      return {
        product: {},
        variants: {}
      };
    }
  }

  function getProductTitle() {
    const product = getSealProductData();

    return (
      product?.title ||
      document.querySelector('.product__title h1')?.textContent?.trim() ||
      ''
    );
  }

  function getVariantRadiosElement() {
    return document.querySelector('variant-radios');
  }

  function getVariants() {
    const variantRadios = getVariantRadiosElement();
    const variantScript = variantRadios?.querySelector(
      'script[type="application/json"]'
    );

    if (!variantScript?.textContent) return [];

    try {
      return JSON.parse(variantScript.textContent);
    } catch (error) {
      console.warn('Variant JSON could not be parsed', error);
      return [];
    }
  }

  function getOptionGroups() {
    const variantRadios = getVariantRadiosElement();
    if (!variantRadios) return [];

    return Array.from(
      variantRadios.querySelectorAll('fieldset.product-form__input')
    )
      .map((fieldset) => {
        const inputs = Array.from(
          fieldset.querySelectorAll('input[type="radio"]')
        );

        return {
          fieldset,
          inputs,
          selectedValue:
            inputs.find((input) => input.checked)?.value || null
        };
      })
      .filter((group) => group.inputs.length > 0);
  }

  function getPurchaseOptionIndex() {
    const variants = getVariants();
    const optionGroups = getOptionGroups();

    if (!variants.length || !optionGroups.length) return -1;

    for (let optionIndex = 0; optionIndex < optionGroups.length; optionIndex += 1) {
      const values = new Map();

      variants.forEach((variant) => {
        const optionValue = variant.options?.[optionIndex];
        if (optionValue == null) return;

        if (!values.has(optionValue)) {
          values.set(optionValue, {
            hasSubscription: false,
            hasNoSubscription: false
          });
        }

        const status = values.get(optionValue);
        const hasSubscription =
          Array.isArray(variant.selling_plan_allocations) &&
          variant.selling_plan_allocations.length > 0;

        if (hasSubscription) {
          status.hasSubscription = true;
        } else {
          status.hasNoSubscription = true;
        }
      });

      const valueStatuses = Array.from(values.values());

      const hasSubscriptionOnlyValue = valueStatuses.some(
        (status) => status.hasSubscription && !status.hasNoSubscription
      );

      const hasOneTimeOnlyValue = valueStatuses.some(
        (status) => !status.hasSubscription && status.hasNoSubscription
      );

      if (hasSubscriptionOnlyValue && hasOneTimeOnlyValue) {
        return optionIndex;
      }
    }

    return -1;
  }

  function markPurchaseOptionFieldset() {
    const optionIndex = getPurchaseOptionIndex();
    const optionGroups = getOptionGroups();

    optionGroups.forEach((group, index) => {
      group.fieldset.classList.toggle(
        'tw-pack-option-fieldset',
        index === optionIndex
      );
    });
  }

  function getPackVariant(packType) {
    const variants = getVariants();
    const optionGroups = getOptionGroups();
    const purchaseOptionIndex = getPurchaseOptionIndex();

    if (!variants.length || purchaseOptionIndex < 0) return null;

    return (
      variants.find((variant) => {
        const matchesOtherOptions = optionGroups.every((group, index) => {
          if (index === purchaseOptionIndex || !group.selectedValue) {
            return true;
          }

          return variant.options?.[index] === group.selectedValue;
        });

        if (!matchesOtherOptions) return false;

        const hasSubscription =
          Array.isArray(variant.selling_plan_allocations) &&
          variant.selling_plan_allocations.length > 0;

        return packType === 'annual'
          ? hasSubscription
          : packType === 'starter'
            ? !hasSubscription
            : false;
      }) || null
    );
  }

  function getPackRadio(packType) {
    const targetVariant = getPackVariant(packType);
    const purchaseOptionIndex = getPurchaseOptionIndex();
    const optionGroups = getOptionGroups();

    if (!targetVariant || purchaseOptionIndex < 0) return null;

    const targetValue = targetVariant.options?.[purchaseOptionIndex];
    const purchaseGroup = optionGroups[purchaseOptionIndex];

    return (
      purchaseGroup?.inputs.find(
        (input) => input.value === targetValue
      ) || null
    );
  }

  function formatMoney(cents) {
  if (cents === null || cents === undefined) return '';

  const currency =
    window.Shopify?.currency?.active ||
    window.Shopify?.currency?.currency ||
    'EUR';

  return new Intl.NumberFormat(
    document.documentElement.lang || 'en',
    {
      style: 'currency',
      currency
    }
  ).format(cents / 100);
}

  function normalizeImageUrl(imageUrl) {
    if (!imageUrl) return '';

    return imageUrl.startsWith('//')
      ? `https:${imageUrl}`
      : imageUrl;
  }

  function getOrCreatePersistentCardsContainer() {
    let container = document.querySelector('.tw-purchase-cards');

    if (container) return container;

    const sealContainer = document.querySelector('.sealsubs-container');

    if (!sealContainer?.parentNode) return null;

    container = document.createElement('div');
    container.className = 'tw-purchase-cards';

    sealContainer.parentNode.insertBefore(
      container,
      sealContainer
    );

    return container;
  }

  function renderPersistentCards() {
    const container = getOrCreatePersistentCardsContainer();

    if (!container) return;

    const annualVariant = getPackVariant('annual');
    const starterVariant = getPackVariant('starter');

    if (!annualVariant || !starterVariant) return;

    const sealCardData = getSealCardData();
    const productTitle = getProductTitle();

    const annualData =
      sealCardData.variants?.[String(annualVariant.id)] || {};

    const starterData =
      sealCardData.variants?.[String(starterVariant.id)] || {};

    const annualAllocation =
      annualVariant.selling_plan_allocations?.[0] || null;

    const annualPrice = annualAllocation?.price
      ? formatMoney(annualAllocation.price)
      : formatMoney(annualVariant.price);

    const annualComparePrice =
      annualAllocation?.compare_at_price
        ? formatMoney(annualAllocation.compare_at_price)
        : '';

    const starterPrice = formatMoney(starterVariant.price);

    const annualPercentage =
      annualAllocation?.compare_at_price &&
      annualAllocation?.price
        ? Math.round(
            (
              1 -
              annualAllocation.price /
                annualAllocation.compare_at_price
            ) * 100
          )
        : null;

    const savingsLabel =
      sealCardData.product?.subscription_savings_label || '';

    const annualImage = normalizeImageUrl(
      annualData.card_image
    );

    const starterImage = normalizeImageUrl(
      starterData.card_image
    );

    const annualTitle =
      sealCardData.product?.subscription_card_title ||
      'Annual subscription';

    const starterTitle =
      sealCardData.product?.one_time_card_title ||
      'One-time purchase';

    const cardBenefit =
      sealCardData.product?.subscription_card_benefit || '';

    const cardFooter =
      sealCardData.product?.subscription_card_footer || '';

    container.innerHTML = `
      <div
        class="tw-persistent-card tw-seal-card tw-seal-card--subscription"
        data-pack-type="annual"
        data-variant-id="${annualVariant.id}"
      >
        <div class="tw-seal-card-content">
          <div class="tw-seal-card-top">
            <div class="tw-seal-card-title-area">
              <p class="tw-seal-card-title">
                ${annualTitle}
              </p>
            </div>

            <div class="tw-seal-card-price-wrap">
              ${
                annualComparePrice
                  ? `
<span class="tw-seal-card-compare-price" data-card-field="annual-compare-price">
                      ${annualComparePrice}
                    </span>
                  `
                  : ''
              }

              <span class="tw-seal-card-price" data-card-field="annual-price">
                ${annualPrice}
              </span>

              ${
                annualPercentage
                  ? `
                    <span class="tw-seal-card-badge" data-card-field="annual-badge">
                      ${savingsLabel} ${annualPercentage}%
                    </span>
                  `
                  : ''
              }
            </div>
          </div>

          <div class="tw-seal-card-body">
            ${
              annualImage
                ? `
                  <img
  class="tw-seal-card-image"
  data-card-field="annual-image"
                    src="${annualImage}"
                    alt="${productTitle}"
                    loading="lazy"
                  >
                `
                : ''
            }

            <div class="tw-seal-card-info">
              <p class="tw-seal-card-product">
                ${productTitle}
              </p>

              ${
                annualData.included_text
                  ? `
                    <p class="tw-seal-card-subtext" data-card-field="annual-included-text">
                      ${annualData.included_text}
                    </p>
                  `
                  : ''
              }
            </div>
          </div>

          ${
            cardBenefit || cardFooter
              ? `
                <div class="tw-seal-card-footer">
                  ${
                    cardBenefit
                      ? `
                        <p class="tw-seal-card-footer-line">
                          <span
                            class="tw-seal-card-benefit-icon"
                            aria-hidden="true"
                          ></span>

                          ${cardBenefit}
                        </p>
                      `
                      : ''
                  }

                  ${
                    cardFooter
                      ? `
                        <p class="tw-seal-card-footer-line">
                          <span
                            class="tw-seal-card-benefit-icon"
                            aria-hidden="true"
                          ></span>

                          ${cardFooter}
                        </p>
                      `
                      : ''
                  }
                </div>
              `
              : ''
          }
        </div>
      </div>

      <div
        class="tw-persistent-card tw-seal-card tw-seal-card--one-time"
        data-pack-type="starter"
        data-variant-id="${starterVariant.id}"
      >
        <div class="tw-seal-card-content">
          <div class="tw-seal-card-top">
            <div class="tw-seal-card-title-area">
              <p class="tw-seal-card-title">
                ${starterTitle}
              </p>
            </div>

            <div class="tw-seal-card-price-wrap">
              <span class="tw-seal-card-price" data-card-field="starter-price">
                ${starterPrice}
              </span>
            </div>
          </div>

          <div class="tw-seal-card-body">
            ${starterImage
  ? `
      <img
        class="tw-seal-card-image"
        data-card-field="starter-image"
        src="${starterImage}"
        alt="${productTitle}"
        loading="lazy"
      >
    `
  : ''
}

            <div class="tw-seal-card-info">
              <p class="tw-seal-card-product">
                ${productTitle}
              </p>

              ${
                starterData.included_text
                  ? `
                    <p class="tw-seal-card-subtext" data-card-field="starter-included-text">
                      ${starterData.included_text}
                    </p>
                  `
                  : ''
              }
            </div>
          </div>
        </div>
      </div>
    `;
  }

  function selectSealPurchaseType(packType) {
    window.setTimeout(() => {
      const selector =
        packType === 'annual'
          ? '.sealsubs-container input.sls-option[data-type="subscription"]:not(:disabled)'
          : '.sealsubs-container input.sls-option[data-type="one_time"]:not(:disabled)';

      const purchaseInput =
        document.querySelector(selector);

      if (purchaseInput && !purchaseInput.checked) {
        purchaseInput.click();
      }
    }, 250);
  }

function bindPersistentCards() {
    const container =
      getOrCreatePersistentCardsContainer();

    if (
      !container ||
      container.dataset.eventsBound === 'true'
    ) {
      return;
    }

    container.addEventListener('click', (event) => {
      const card = event.target.closest(
        '.tw-persistent-card'
      );

      if (!card) return;

      const packType = card.dataset.packType;
      const packRadio = getPackRadio(packType);

      if (packRadio && !packRadio.checked) {
        packRadio.click();
      }

      selectSealPurchaseType(packType);
    });

    container.dataset.eventsBound = 'true';
  }

  function updatePersistentCardsState() {
    const container =
      getOrCreatePersistentCardsContainer();

    if (!container) return;

    const annualRadio = getPackRadio('annual');
    const starterRadio = getPackRadio('starter');

    const annualCard = container.querySelector(
      '.tw-persistent-card[data-pack-type="annual"]'
    );

    const starterCard = container.querySelector(
      '.tw-persistent-card[data-pack-type="starter"]'
    );

    annualCard?.classList.toggle(
      'sls-active',
      Boolean(annualRadio?.checked)
    );

    starterCard?.classList.toggle(
      'sls-active',
      Boolean(starterRadio?.checked)
    );
  }

  function initSealCustomCards() {
  // Countertop renders its own cards (countertop-purchase-cards.liquid).
  if (document.querySelector('[data-tw-ct-cards]')) return;

  const sealContainer = document.querySelector(
    '.sealsubs-container'
  );

  if (!sealContainer) return;

  markPurchaseOptionFieldset();
  renderPersistentCards();
  bindPersistentCards();
  updatePersistentCardsState();

  sealContainer.classList.add('tw-seal-ready');
}

  function runAfterSealUpdates() {
  window.requestAnimationFrame(initSealCustomCards);
}

  document.addEventListener(
    'DOMContentLoaded',
    runAfterSealUpdates
  );

  document.addEventListener(
    'sealsubs:subscription_widget_created',
    runAfterSealUpdates
  );

  document.addEventListener('change', (event) => {
    if (
      event.target.matches('input[type="radio"]') ||
      event.target.matches('select')
    ) {
      runAfterSealUpdates();
    }
  });
})();